import React from 'react';
import { useSelector } from 'react-redux';
import './ProjectInfoCard.css';
import { selectProjectType } from '../../../redux/projectTypeSlice';
import { PROJECT_TYPES } from '../../../constants/projectTypes';

const PROJECT_TYPE_ICONS = {
  // A — Tek Bağımsız Bölüm: tek katlı ev
  [PROJECT_TYPES.SINGLE_UNIT]: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 20h20" />
      <path d="M5 20V8l7-5 7 5v12" />
      <path d="M9 20v-6h6v6" />
    </svg>
  ),
  // B — Çok Katlı Tek Sayaç: iki katlı ev (dublex)
  [PROJECT_TYPES.MULTI_FLOOR_SINGLE_METER]: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 21h20" />
      <path d="M5 21V9l7-5 7 5v12" />
      <line x1="5" y1="15" x2="19" y2="15" />
      <rect x="7" y="10" width="2.5" height="2.5" />
      <rect x="14.5" y="10" width="2.5" height="2.5" />
      <path d="M10 21v-4h4v4" />
    </svg>
  ),
  // C — Çok Sayaçlı Yapı: çok daireli apartman (çatı y=5'e çekildi)
  [PROJECT_TYPES.MULTI_METER]: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 5l9-4 9 4v16H3V5z" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="3" y1="15" x2="21" y2="15" />
      <line x1="9" y1="5" x2="9" y2="21" />
      <line x1="15" y1="5" x2="15" y2="21" />
      <path d="M10 21v-3h4v3" />
    </svg>
  ),
  // D — Yüksek Katlı Yapı: geniş + uzun bina, 4 kat, anten
  [PROJECT_TYPES.HIGH_RISE]: (
    <svg width="27" height="27" viewBox="0 -3 24 27" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="-3" x2="12" y2="-1" />
      <rect x="5" y="-1" width="14" height="23" />
      <line x1="5" y1="4" x2="19" y2="4" />
      <line x1="5" y1="9" x2="19" y2="9" />
      <line x1="5" y1="14" x2="19" y2="14" />
      <line x1="5" y1="19" x2="19" y2="19" />
      <rect x="7" y="0.5" width="2" height="2" />
      <rect x="15" y="0.5" width="2" height="2" />
      <rect x="7" y="5.5" width="2" height="2" />
      <rect x="15" y="5.5" width="2" height="2" />
      <rect x="7" y="10.5" width="2" height="2" />
      <rect x="15" y="10.5" width="2" height="2" />
      <rect x="7" y="15.5" width="2" height="2" />
      <rect x="15" y="15.5" width="2" height="2" />
      <path d="M10 22v-3h4v3" />
    </svg>
  ),
};

const ProjectInfoCard = () => {
  const projectName = useSelector((state) => state.project.projectName);
  const meta = useSelector((state) => state.project.projectMetadata);
  const projectType = useSelector(selectProjectType);

  if (!projectName || projectName === 'Yeni Proje') return null;

  // Build address lines: line1 = city/district, line2 = neighborhood/street
  const addressLine1Parts = [meta.city, meta.district].filter(Boolean);
  const addressLine1 = addressLine1Parts.join(', ');
  const addressLine2Parts = [meta.neighborhood, meta.street].filter(Boolean);
  const addressLine2 = addressLine2Parts.join(', ');

  // Build parcel line: Ada / Pafta / Parsel
  const parcelParts = [];
  if (meta.ada) parcelParts.push(`Ada: ${meta.ada}`);
  if (meta.pafta) parcelParts.push(`Pafta: ${meta.pafta}`);
  if (meta.parsel) parcelParts.push(`Parsel: ${meta.parsel}`);
  const parcelLine = parcelParts.join('  ·  ');

  const icon = PROJECT_TYPE_ICONS[projectType] || PROJECT_TYPE_ICONS[PROJECT_TYPES.SINGLE_UNIT];

  return (
    <div className="project-info-card">
      <span className="project-info-icon">{icon}</span>
      <div className="project-info-text">
        <span className="project-info-name" title={projectName}>
          {projectName.replace(/\.[^.]+$/, '')}
        </span>
        {addressLine1 && (
          <span className="project-info-address" title={addressLine1}>
            {addressLine1}
          </span>
        )}
        {addressLine2 && (
          <span className="project-info-address" title={addressLine2}>
            {addressLine2}
          </span>
        )}
        {parcelLine && (
          <span className="project-info-parcel" title={parcelLine}>
            {parcelLine}
          </span>
        )}
      </div>
    </div>
  );
};

export default ProjectInfoCard;
